import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Common } from '../../shared/common';
import { catchError, Observable, retry } from 'rxjs';
import 'rxjs-compat/add/observable/of';
import { Constants } from '../constant';
import { Events } from '../models/events';

@Injectable()
export class EventsService {

  constructor(private http: HttpClient) { }

  getSchedulesByType(startDate, type) {
    return this.http.get<Events>(Constants.getApiEndpoint() + '/schedule_detail/' + type + '?startDate=' + startDate)
      .pipe(retry(1), catchError(Common.handleError));
  }

  downloadData(startDate, type) {
    return this.http.get<Events>(Constants.getApiEndpoint() + '/schedule_detail/' + type + '/download?startDate=' + startDate)
      .pipe(retry(1), catchError(Common.handleError));
  }

  getSchedulesByOther(type, faculty_id, startDate, viewType) {
    let field = Common.urls[type]
    return this.http.get<Events>(Constants.getApiEndpoint() + '/schedule_detail/' + field.path + '?' + field.id_field + '=' + faculty_id + '&startDate=' + startDate + '&viewType=' + viewType)
      .pipe(retry(1), catchError(Common.handleError));
  }

  getSchedulesList(pgIndex: number, pageSize: number, sortBy?, direction?, search?) {
    return this.http.get<Events>(Constants.getApiEndpoint() + '/schedule/get_schedule?page=' + pgIndex + "&size=" + pageSize + "&sort=" + sortBy + "," + direction + "&search=" + search)
      .pipe(retry(1), catchError(Common.handleError));
  }

  getSchedulesDetailList(scheduler_id: string, pgIndex: number) {
    return this.http.get<Events>(Constants.getApiEndpoint() + '/schedule_detail/get_schedule_detail_by_schedule?scheduler_id=' + scheduler_id + '&page=' + pgIndex)
      .pipe(retry(1), catchError(Common.handleError));
  }

  getEventsList(pgIndex: number, pageSize: number, sortBy?, direction?, search?) {
    return this.http.get<Events>(Constants.getApiEndpoint() + '/schedule/get_event?page=' + pgIndex + "&size=" + pageSize + "&sort=" + sortBy + "," + direction + "&search=" + search)
      .pipe(retry(1), catchError(Common.handleError));
  }

  getRoomViewList(pgIndex: number, room_id: string) {
    return this.http.get<Events>(Constants.getApiEndpoint() + '/schedule_detail/current_room_view?page=' + pgIndex + '&room_id=' + room_id)
      .pipe(retry(1), catchError(Common.handleError));
  }

  getFacultyViewList(pgIndex: number, faculty_id: string) {
    return this.http.get<Events>(Constants.getApiEndpoint() + '/schedule_detail/current_faculty_view?page=' + pgIndex + '&faculty_id=' + faculty_id)
      .pipe(retry(1), catchError(Common.handleError));
  }

  getWeeklyViewList(pgIndex: number) {
    return this.http.get<Events>(Constants.getApiEndpoint() + '/schedule_detail/current_weekly_view?page=' + pgIndex)
      .pipe(retry(1), catchError(Common.handleError));
  }

  getSchedule(id: string) {
    if (id === "new") {
      return Observable.of(this.initializeSchedule());
    };
    return this.http.get<Events>(Constants.getApiEndpoint() + '/schedule/' + id).pipe(retry(1), catchError(Common.handleError));
  }

  deleteSchedule(id: string) {
    return this.http.delete<Events>(Constants.getApiEndpoint() + '/schedule/' + id).pipe(retry(1), catchError(Common.handleError));
  }

  saveSchedule(schedule: Events) {
    if (schedule.id === null) {
      return this.createSchedule(schedule);
    }
    return this.updateSchedule(schedule);
  }

  private createSchedule(schedule: Events) {
    schedule.id = undefined;
    return this.http.post<Events>(Constants.getApiEndpoint() + '/schedule', JSON.stringify(schedule), Common.httpOptions)
      .pipe(retry(1), catchError(Common.handleError));
  }

  private updateSchedule(schedule: Events) {
    return this.http.post<Events>(Constants.getApiEndpoint() + '/schedule', JSON.stringify(schedule), Common.httpOptions)
      .pipe(retry(1), catchError(Common.handleError));
  }

  updateScheduleDetails(schedule: Events) {
    return this.http.put<Events>(Constants.getApiEndpoint() + '/schedule_detail/cancelSchedule', JSON.stringify(schedule), Common.httpOptions)
      .pipe(retry(1), catchError(Common.handleError));
  }

  initializeSchedule(): Events {
    // Return an initialized object
    return {
      id: "",
      session_id: "",
      room_id: "",
      faculty_id: "",
      faculty_id1: "",
      term_course_id: "",
      day: "",
      start_date: new Date(),
      end_date: new Date(),
      start_date_ts: 0,
      end_date_ts: 0,
      name: "",
      booking_detail: "",
      organisationIds: "",
      theme: ""
    };
  }
}
